import '../style/copy-BIMV_zGe.css'
import { defineComponent as z, ref as m, computed as f, watch as N, openBlock as o, createElementBlock as t, normalizeClass as B, renderSlot as p, createTextVNode as E, toDisplayString as d, createBlock as K, unref as s, withKeys as h, withModifiers as v, createCommentVNode as n, createElementVNode as A, createVNode as V } from "vue";
import { useClipboard as $ } from "@vueuse/core";
import _ from "./icon-button.js";
import { DEFAULT_RIPPLE_SETTING as b } from "./constant/ripple.js";
const x = {
  key: 0,
  class: "e-copy__label"
}, L = { class: "e-copy__layer" }, R = {
  key: 0,
  class: "e-copy__content mr-8"
}, D = {
  key: 0,
  class: "e-copy__helper"
}, I = ["value"], U = /* @__PURE__ */ z({
  name: "e-copy",
  __name: "copy",
  props: {
    label: {},
    text: {},
    showText: { type: Boolean, default: !0 },
    iconSize: { default: 20 },
    helper: {},
    withStyle: { type: Boolean },
    maskable: { type: Boolean }
  },
  emits: ["success"],
  setup(k, { emit: w }) {
    const a = k, { copy: C, copied: S, isSupported: u } = $(), l = m(!1), i = m(null), c = w, T = f(() => [
      "e-copy",
      {
        "e-copy--with-style": a.withStyle,
        "e-copy--masked": l.value
      }
    ]), g = f(() => {
      const e = a.text || "";
      return l.value ? new Array(e.length).fill("*").join("") : e;
    });
    N(S, (e) => {
      e && c("success");
    });
    function r() {
      u.value ? C(a.text) : typeof global < "u" && global.NativeAndroid?.copyToClipboard ? (global.NativeAndroid.copyToClipboard(a.text), c("success")) : i.value && (i.value.select(), document.execCommand("copy"), c("success"));
    }
    function y() {
      l.value = !l.value;
    }
    return (e, M) => (o(), t("div", {
      class: B(T.value)
    }, [
      p(e.$slots, "label", {}, () => [
        e.label ? (o(), t("div", x, [
          E(d(e.label) + " ", 1),
          e.maskable ? (o(), K(s(_), {
            key: 0,
            "ml-8": "",
            tabindex: "0",
            "aria-label": "masking",
            icon: l.value ? "eye-slash" : "eye",
            ripple: s(b),
            "icon-size": e.iconSize,
            "hover-scale": "",
            onClick: y,
            onKeydown: h(v(y, ["stop", "prevent"]), ["space", "enter"])
          }, null, 8, ["icon", "ripple", "icon-size", "onKeydown"])) : n("", !0)
        ])) : n("", !0)
      ]),
      A("div", L, [
        p(e.$slots, "default", { copy: r }, () => [
          e.showText ? (o(), t("div", R, d(g.value), 1)) : n("", !0),
          V(s(_), {
            class: "e-copy__icon",
            tabindex: "0",
            "aria-label": "copy",
            icon: "copy",
            "hover-scale": "",
            "icon-size": e.iconSize,
            ripple: s(b),
            onClick: r,
            onKeydown: h(v(r, ["stop", "prevent"]), ["space", "enter"])
          }, null, 8, ["icon-size", "ripple", "onKeydown"])
        ])
      ]),
      p(e.$slots, "helper", {}, () => [
        e.helper ? (o(), t("div", D, d(e.helper), 1)) : n("", !0)
      ]),
      s(u) ? n("", !0) : (o(), t("input", {
        key: 0,
        ref_key: "inputRef",
        ref: i,
        class: "e-copy--reserved",
        value: e.text,
        readonly: ""
      }, null, 8, I))
    ], 2));
  }
});
export {
  U as default
};
//# sourceMappingURL=copy.js.map
